import {
  collection,
  query,
  where,
  orderBy,
  getDocs
} from 'firebase/firestore';
import { Firestore } from '../Firebase';
import { areaConverter } from '../model/Area';

export async function getAreas(
  parent: string,
  isPrivileged: boolean = false
) {
  const colRef = collection(Firestore, 'areas').withConverter(areaConverter);
  let q = query(colRef, where('parent', '==', parent))

  if (!isPrivileged) {
    q = query(q, where('public', '==', true));
  }

  q = query(q, orderBy('order'));

  return (await getDocs(q)).docs.map(doc => doc.data());
}

